const earnMorePoints = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill='${color_mode}' d="M15.5 12a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zM4 16h2a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V17a1 1 0 0 1 1-1z"/>
          <path fill="${color}" d="M13.055 17.817l-4.524.803a.75.75 0 0 1-.262-1.477l4.589-.815.131-.011h4.336c2.261 0 3.787 1.425 3.107 4.142a.75.75 0 0 1-.727.568H15.04a.75.75 0 0 1 0-1.5h4.04c.127-1.223-.545-1.71-1.755-1.71h-4.27zm7.822 1.615l-.627.4a.75.75 0 0 1-.807-1.264l.794-.507a.75.75 0 0 1 .404-.118c.25 0 .493-.085.686-.24l2.509-2.007.088-.06a2.785 2.785 0 0 1 3.574.641l.095.118a2.489 2.489 0 0 1-.19 3.35l-5.24 5.343a7.219 7.219 0 0 1-4.612 1.662h-4.577c-.756 0-1.505-.14-2.206-.411L8.13 25.317a.75.75 0 0 1 .542-1.399l2.639 1.022c.528.205 1.093.31 1.664.31h4.577c1.338 0 2.633-.466 3.598-1.263l5.196-5.305a.994.994 0 0 0 .082-1.344l-.095-.117a1.285 1.285 0 0 0-1.606-.316l-2.462 1.97a2.597 2.597 0 0 1-1.387.557z"/>
      </g>
    </svg>
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const spendYourPoints = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="evenodd">
          <path fill="${color_mode}" d="M14 8.989a5.193 5.193 0 0 1-2.13 1.509c-1.148.435-2.504.435-4.058.024a.75.75 0 0 1 .383-1.45c1.274.336 2.317.336 3.142.023.471-.178.888-.442 1.255-.796h-2.167a3.007 3.007 0 0 1-3.007-3.006c0-1.677 1.13-3.043 2.688-3.043 1.359 0 2.683.899 3.554 2.252l1.335 1.969 1.334-1.969c.871-1.353 2.196-2.252 3.555-2.252 1.557 0 2.687 1.366 2.687 3.043a3.007 3.007 0 0 1-3.007 3.006h-2.216c.367.354.784.618 1.255.796.825.313 1.868.313 3.142-.024a.75.75 0 0 1 .383 1.45c-1.554.412-2.91.412-4.057-.023A5.182 5.182 0 0 1 16 9.058V25.55a.45.45 0 0 1-.45.45h-1.1a.45.45 0 0 1-.45-.45V8.989zm5.564-2.19c.833 0 1.507-.674 1.507-1.506 0-.905-.527-1.543-1.187-1.543-.786 0-1.675.603-2.303 1.579l-.997 1.47h2.98zm-6.158 0l-.997-1.47c-.628-.976-1.517-1.579-2.303-1.579-.66 0-1.188.638-1.188 1.543 0 .832.675 1.506 1.507 1.506h2.98z"/>
          <path fill="${color}" fill-rule="nonzero" d="M25.185 14.737l-.967 10.425a1.75 1.75 0 0 1-1.742 1.588H7.524a1.75 1.75 0 0 1-1.742-1.588l-.967-10.425C3.66 14.615 2.75 13.667 2.75 12.5v-2c0-1.25 1.045-2.25 2.318-2.25h.541a.75.75 0 0 1 0 1.5h-.54c-.46 0-.819.343-.819.75v2c0 .407.359.75.818.75h19.864c.459 0 .818-.343.818-.75v-2c0-.407-.359-.75-.818-.75h-.504a.75.75 0 0 1 0-1.5h.504c1.273 0 2.318 1 2.318 2.25v2c0 1.166-.91 2.115-2.065 2.237zm-18.862.013l.952 10.273a.25.25 0 0 0 .25.227h14.95a.25.25 0 0 0 .25-.227l.952-10.273H6.323z"/>
      </g>
  </svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const orderOnline = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="evenodd">
          <path fill="${color_mode}" fill-rule="nonzero" d="M24.196 25.257a.75.75 0 1 1 .206 1.486c-.075.01.704.01-19.828.007a1.25 1.25 0 0 1-1.238-1.422l2.305-16.57A1.75 1.75 0 0 1 7.374 7.25h.612a.75.75 0 1 1 0 1.5h-.612a.25.25 0 0 0-.247.216L4.862 25.25c5.9 0 19.378.001 19.334.007zm-5.922-16.07A.751.751 0 0 1 18.25 9V5.937c0-1.757-1.452-3.187-3.25-3.187s-3.25 1.43-3.25 3.188V9a.751.751 0 0 1-.024.187 1.5 1.5 0 1 1-1.452 0A.751.751 0 0 1 10.25 9V5.937c0-2.591 2.13-4.687 4.75-4.687s4.75 2.096 4.75 4.688V9a.751.751 0 0 1-.024.187 1.5 1.5 0 1 1-1.452 0zm3.7-.437a.75.75 0 1 1 0-1.5h.652a1.75 1.75 0 0 1 1.733 1.509l.36 2.59a.75.75 0 1 1-1.485.206l-.36-2.59a.25.25 0 0 0-.248-.215h-.653zM14 8.75a.75.75 0 1 1 0-1.5h2a.75.75 0 1 1 0 1.5h-2z"/>
          <path fill="${color}" d="M18.934 17.755l.73-3.928a.5.5 0 0 1 .573-.402l3.94.658a1 1 0 0 1 .655.413l3.064 4.376a.5.5 0 0 1-.123.697L22.86 23.01a.5.5 0 0 1-.697-.123l-3.064-4.376a1 1 0 0 1-.164-.756z"/>
      </g>
  </svg>
  
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const signUp = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="evenodd">
          <path fill="${color_mode}" fill-rule="nonzero" d="M23.25 16a.75.75 0 1 1 1.5 0v5a.75.75 0 1 1-1.5 0v-5zM4.253 21.063A.76.76 0 0 1 4.25 21v-5a.75.75 0 1 1 1.5 0v5h12.5v-5a.75.75 0 1 1 1.5 0v5h5.536c.946 0 1.714.768 1.714 1.714v1.572c0 .946-.768 1.714-1.714 1.714H4.714A1.714 1.714 0 0 1 3 24.286v-1.572c0-.787.53-1.45 1.253-1.651zm.461 1.437a.214.214 0 0 0-.214.214v1.572c0 .118.096.214.214.214h20.572a.214.214 0 0 0 .214-.214v-1.572a.214.214 0 0 0-.214-.214H4.714zM6.72 5.25L4.65 8.872a.75.75 0 0 1-1.302-.744l2.18-3.818c.223-.358.617-.56 1.04-.56h16.863c.422 0 .816.202 1.054.585l2.165 3.793a.75.75 0 1 1-1.302.744L23.282 5.25H6.719zm3.514 10.611a.75.75 0 1 1 .881 1.214l-2.427 1.763a.75.75 0 0 1-.881-1.214l2.427-1.763zm4.213 0a.75.75 0 1 1 .882 1.214l-3.64 2.645a.75.75 0 0 1-.882-1.214l3.64-2.645z"/>
          <path fill="${color}" d="M27 10.714c0 1.894-1.482 3.429-3.31 3.429-1.247 0-2.332-.714-2.897-1.768-.565 1.054-1.65 1.768-2.896 1.768-1.247 0-2.332-.714-2.897-1.768-.565 1.054-1.65 1.768-2.897 1.768-1.246 0-2.331-.714-2.896-1.768-.565 1.054-1.65 1.768-2.897 1.768-1.828 0-3.31-1.535-3.31-3.429 0-.374.303-.677.677-.677h22.646c.374 0 .677.303.677.677z"/>
      </g>
  </svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const birthDay = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M12.75 12.75V9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3.75h5.25a2.75 2.75 0 0 1 2.75 2.75V22a.75.75 0 1 1-1.5 0v-6.5c0-.69-.56-1.25-1.25-1.25h-15c-.69 0-1.25.56-1.25 1.25V22a.75.75 0 1 1-1.5 0v-6.5a2.75 2.75 0 0 1 2.75-2.75h5.25zm1.5 0h1.5v-3h-1.5v3zM2 25.75a.75.75 0 1 1 0-1.5h26a.75.75 0 1 1 0 1.5H2z"/>
          <path fill="${color}" d="M23.75 19.63a3.993 3.993 0 0 1-1.69.37c-.881 0-1.712-.28-2.353-.769a3.891 3.891 0 0 1-2.354.769c-.88 0-1.712-.28-2.353-.769a3.891 3.891 0 0 1-2.353.769c-.882 0-1.713-.28-2.354-.769A3.891 3.891 0 0 1 7.94 20a4.013 4.013 0 0 1-1.69-.368v-2.26c.253.52.9.914 1.69.914.692 0 1.301-.309 1.606-.771a.903.903 0 0 1 1.495 0c.304.462.914.77 1.606.77.691 0 1.3-.308 1.606-.77a.903.903 0 0 1 1.494 0c.305.462.915.77 1.606.77.692 0 1.302-.308 1.606-.77a.903.903 0 0 1 1.495 0c.305.462.914.77 1.606.77.79 0 1.437-.393 1.69-.91v2.256zM15 7c-1.105 0-2-.936-2-2.092 0-.77.667-1.907 2-3.41 1.333 1.503 2 2.64 2 3.41C17 6.064 16.105 7 15 7z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const fbLike = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M5.5 12h3a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 8.5 24h-3A1.5 1.5 0 0 1 4 22.5v-9A1.5 1.5 0 0 1 5.5 12"/>
          <path fill="${color}" d="M23.432 11.275a3.476 3.476 0 0 1 3.475 3.476c0 1.896-.364 3.775-1.072 5.534l-.599 1.488a4.75 4.75 0 0 1-4.406 2.977h-3.957a6.75 6.75 0 0 1-3.231-.824l-2.001-1.09a.75.75 0 1 1 .718-1.317l2 1.09a5.25 5.25 0 0 0 2.514.641h3.957a3.25 3.25 0 0 0 3.015-2.037l.599-1.488c.636-1.581.963-3.27.963-4.974a1.976 1.976 0 0 0-1.975-1.976h-3.749c-.69 0-1.25-.56-1.25-1.25V7.637c0-.496-.155-.98-.444-1.384a1.202 1.202 0 0 0-.978-.503h-.667a.25.25 0 0 0-.25.25v2.753a4.75 4.75 0 0 1-2.083 3.93l-1.59 1.08a.75.75 0 0 1-.842-1.242l1.59-1.079a3.25 3.25 0 0 0 1.425-2.689V6c0-.966.783-1.75 1.75-1.75h.667c.872 0 1.69.421 2.198 1.13a3.88 3.88 0 0 1 .724 2.257v3.638h3.499z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const fbShare = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M23.526 21.36l-2.683 1.73a2.134 2.134 0 0 1-.02.768l2.672 1.723a1.768 1.768 0 1 1-.842 1.242l-2.642-1.704a2.118 2.118 0 1 1 .09-3.335l2.558-1.65a1.768 1.768 0 1 1 .867 1.226z"/>
          <path fill="${color}" d="M18.117 4H3.883A.883.883 0 0 0 3 4.883v14.234c0 .488.395.883.883.883h7.669v-6.188H9.469V11.39h2.083V9.608c0-2.066 1.263-3.191 3.106-3.191a17.71 17.71 0 0 1 1.86.093v2.16h-1.27c-1.004 0-1.2.475-1.2 1.176v1.542h2.4l-.311 2.422h-2.103V20h4.083a.883.883 0 0 0 .883-.883V4.883A.883.883 0 0 0 18.117 4z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const twitterShare = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M8.29 22.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.354-.012-.53A8.349 8.349 0 0 0 22 7.922a8.19 8.19 0 0 1-2.357.645 4.118 4.118 0 0 0 1.804-2.27 8.223 8.223 0 0 1-2.605.997 4.107 4.107 0 0 0-6.993 3.742 11.65 11.65 0 0 1-8.457-4.287 4.106 4.106 0 0 0 1.27 5.477 4.073 4.073 0 0 1-1.862-.513v.052a4.105 4.105 0 0 0 3.292 4.022 4.097 4.097 0 0 1-1.853.07 4.108 4.108 0 0 0 3.834 2.85A8.234 8.234 0 0 1 2 20.408a11.617 11.617 0 0 0 6.29 1.84"/>
          <path fill="${color}" d="M23.526 21.36l-2.683 1.73a2.134 2.134 0 0 1-.02.768l2.672 1.723a1.768 1.768 0 1 1-.842 1.242l-2.642-1.704a2.118 2.118 0 1 1 .09-3.335l2.558-1.65a1.768 1.768 0 1 1 .867 1.226z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const twitterFollow = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M8.29 23.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.354-.012-.53A8.349 8.349 0 0 0 22 8.922a8.19 8.19 0 0 1-2.357.645 4.118 4.118 0 0 0 1.804-2.27 8.223 8.223 0 0 1-2.605.997 4.107 4.107 0 0 0-6.993 3.742 11.65 11.65 0 0 1-8.457-4.287 4.106 4.106 0 0 0 1.27 5.477 4.073 4.073 0 0 1-1.862-.513v.052a4.105 4.105 0 0 0 3.292 4.022 4.097 4.097 0 0 1-1.853.07 4.108 4.108 0 0 0 3.834 2.85A8.234 8.234 0 0 1 2 21.408a11.617 11.617 0 0 0 6.29 1.84"/>
          <path fill="${color}" d="M26 14.5h1.75a.75.75 0 1 1 0 1.5H26v1.75a.75.75 0 1 1-1.5 0V16h-1.75a.75.75 0 1 1 0-1.5h1.75v-1.75a.75.75 0 1 1 1.5 0v1.75z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const instaFollow = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="evenodd">
          <path fill="${color_mode}" d="M11 6c2.444 0 2.75.01 3.71.054.959.044 1.613.196 2.185.419.592.23 1.094.537 1.594 1.038.5.5.809 1.002 1.039 1.594.222.572.374 1.226.418 2.184.044.96.054 1.267.054 3.711s-.01 2.75-.054 3.71c-.044.959-.196 1.613-.418 2.185a4.412 4.412 0 0 1-1.039 1.594c-.5.5-1.002.809-1.594 1.039-.572.222-1.226.374-2.184.418-.96.044-1.267.054-3.711.054s-2.75-.01-3.71-.054c-.959-.044-1.613-.196-2.185-.418a4.412 4.412 0 0 1-1.594-1.039c-.5-.5-.809-1.002-1.038-1.594-.223-.572-.375-1.226-.419-2.184C2.01 17.75 2 17.444 2 15s.01-2.75.054-3.71c.044-.959.196-1.613.419-2.185A4.411 4.411 0 0 1 3.51 7.51c.5-.5 1.002-.809 1.594-1.038.572-.223 1.226-.375 2.184-.419C8.25 6.01 8.556 6 11 6zm0 1.622c-2.403 0-2.688.009-3.637.052-.877.04-1.354.187-1.67.31-.421.163-.72.358-1.036.673-.315.315-.51.615-.673 1.035-.123.317-.27.794-.31 1.671-.043.95-.052 1.234-.052 3.637s.009 2.688.052 3.637c.04.877.187 1.354.31 1.67.163.421.358.72.673 1.036.315.315.615.51 1.035.673.317.123.794.27 1.671.31.95.043 1.234.052 3.637.052s2.688-.009 3.637-.052c.877-.04 1.354-.187 1.67-.31.421-.163.72-.358 1.036-.673.315-.315.51-.615.673-1.035.123-.317.27-.794.31-1.671.043-.95.052-1.234.052-3.637s-.009-2.688-.052-3.637c-.04-.877-.187-1.354-.31-1.67a2.788 2.788 0 0 0-.673-1.036 2.788 2.788 0 0 0-1.035-.673c-.317-.123-.794-.27-1.671-.31-.95-.043-1.234-.052-3.637-.052zM6.378 15a4.622 4.622 0 1 1 9.244 0 4.622 4.622 0 0 1-9.244 0zM11 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm4.804-6.724a1.08 1.08 0 1 1 0-2.16 1.08 1.08 0 0 1 0 2.16z"/>
          <path fill="${color}" fill-rule="nonzero" d="M26 14.5h1.75a.75.75 0 1 1 0 1.5H26v1.75a.75.75 0 1 1-1.5 0V16h-1.75a.75.75 0 1 1 0-1.5h1.75v-1.75a.75.75 0 1 1 1.5 0v1.75z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const freeProduct = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="evenodd">
          <path fill="${color_mode}" d="M21.741 13.919l-2.643 2.643a.45.45 0 0 1-.636 0l-.778-.778a.45.45 0 0 1 0-.636l2.698-2.698a5.194 5.194 0 0 1-2.58-.44c-1.118-.503-2.077-1.462-2.885-2.851a.75.75 0 1 1 1.296-.755c.663 1.139 1.4 1.877 2.205 2.239.46.206.94.315 1.45.324l-1.532-1.532a3.007 3.007 0 0 1 0-4.252c1.186-1.186 2.95-1.353 4.052-.252.96.962 1.262 2.534.92 4.106l-.448 2.336 2.336-.448c1.573-.342 3.145-.04 4.106.92 1.101 1.102.934 2.867-.251 4.053a3.007 3.007 0 0 1-4.253 0l-1.567-1.568c.01.51.118.991.325 1.45.362.805 1.1 1.543 2.238 2.205a.75.75 0 0 1-.754 1.297c-1.39-.809-2.349-1.768-2.852-2.886a5.182 5.182 0 0 1-.447-2.477zm4.118.918a1.507 1.507 0 0 0 2.131 0c.64-.64.718-1.464.251-1.93-.556-.556-1.611-.759-2.745-.513l-1.745.335 2.108 2.108zm-4.355-4.355l-2.107-2.108a1.507 1.507 0 0 1 0-2.13c.64-.64 1.464-.718 1.93-.252.556.556.758 1.611.512 2.745l-.335 1.745zM13.448 15h1.104c.247 0 .448.2.448.448v11.104c0 .247-.2.448-.448.448h-1.104a.448.448 0 0 1-.448-.448V15.448c0-.247.2-.448.448-.448z"/>
          <path fill="${color}" fill-rule="nonzero" d="M22.618 21.78l-6.029-6.03H5.823l.952 10.273a.25.25 0 0 0 .25.227h14.95a.25.25 0 0 0 .25-.227l.393-4.244zm1.379 1.378l-.279 3.004a1.75 1.75 0 0 1-1.742 1.588H7.024a1.75 1.75 0 0 1-1.742-1.588L4.253 15.069A.75.75 0 0 1 5 14.25h10.09l-4.265-4.264a2.25 2.25 0 0 1 0-3.182l1.414-1.414a2.25 2.25 0 0 1 3.182 0l.366.365a.75.75 0 0 1-1.06 1.061l-.367-.366a.75.75 0 0 0-1.06 0l-1.414 1.414a.75.75 0 0 0 0 1.061L25.32 22.36a.75.75 0 0 0 1.06 0l1.414-1.414a.75.75 0 0 0 0-1.06l-.34-.341a.75.75 0 0 1 1.06-1.061l.341.34a2.25 2.25 0 0 1 0 3.183l-1.414 1.414a2.25 2.25 0 0 1-3.182 0l-.263-.263zM7.519 8.608a.75.75 0 0 1-1.5 0V7.015a.75.75 0 1 1 1.5 0v1.593zm-5.22.527a.75.75 0 0 1 1.067-1.054l1.18 1.196A.75.75 0 0 1 3.48 10.33L2.299 9.135zm.533 2.708a.75.75 0 0 1 0 1.5H1.258a.75.75 0 1 1 0-1.5h1.574z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const percentageCoupon = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M4.745 14.004a.75.75 0 1 1 1.228-.86l.574.819a.75.75 0 0 1-1.229.86l-.573-.819zm2.294 3.277a.75.75 0 1 1 1.229-.86l.573.818a.75.75 0 0 1-1.228.86l-.574-.818zm2.294 3.276a.75.75 0 0 1 1.229-.86l.574.819a.75.75 0 1 1-1.23.86l-.573-.819zm2.295 3.277a.75.75 0 1 1 1.228-.86l.574.819a.75.75 0 0 1-1.229.86l-.573-.82z"/>
          <path fill="${color}" d="M29.132 14.016c.55.786.383 1.868-.396 2.413l-17.27 12.093c-.779.545-1.853.332-2.403-.454L7.46 25.78a3.75 3.75 0 0 1-.634-2.723l.027-.178a2.697 2.697 0 0 0-.456-1.959l-.132-.188a2.697 2.697 0 0 0-1.684-1.098l-.177-.035a3.75 3.75 0 0 1-2.342-1.528L.46 15.781c-.55-.786-.383-1.868.396-2.413l17.27-12.093c.78-.546 1.853-.333 2.403.453l1.603 2.29a3.75 3.75 0 0 1 .635 2.723l-.028.177a2.697 2.697 0 0 0 .456 1.96l.132.188c.399.57 1.003.963 1.685 1.098l.176.035a3.75 3.75 0 0 1 2.342 1.527l1.603 2.29zm-4.237-2.346l-.176-.035c-1.062-.21-2-.823-2.622-1.71l-.131-.187a4.197 4.197 0 0 1-.71-3.048l.027-.178a2.25 2.25 0 0 0-.38-1.634L19.3 2.588c-.083-.118-.226-.146-.314-.085L1.716 14.596c-.09.062-.111.206-.028.325L3.29 17.21a2.25 2.25 0 0 0 1.405.916l.176.035c1.062.21 2.001.823 2.622 1.71l.132.188c.62.887.875 1.979.71 3.048l-.028.178a2.25 2.25 0 0 0 .38 1.634l1.604 2.289c.083.119.225.147.314.085L27.876 15.2c.088-.061.11-.205.027-.324l-1.603-2.29a2.25 2.25 0 0 0-1.405-.916zm-9.093 8.179l-1.478-.26L16.29 8.445l1.477.26-1.964 11.143zm-2.644-4.595a2.25 2.25 0 1 1-2.581-3.686 2.25 2.25 0 0 1 2.58 3.686zm-.86-1.229a.75.75 0 1 0-.861-1.229.75.75 0 0 0 .86 1.23zm9.216 2.702a2.25 2.25 0 1 1-2.581-3.686 2.25 2.25 0 0 1 2.581 3.686zm-.86-1.228a.75.75 0 1 0-.86-1.23.75.75 0 0 0 .86 1.23z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const freeShippingCoupon = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M10.25 12.25V7.635c0-.75.577-1.385 1.327-1.385h13.846c.75 0 1.327.636 1.327 1.385v1.882a.75.75 0 1 1-1.5 0V7.75h-13.5V17a.75.75 0 1 1-1.5 0v-3.25H7.151c-.01 0-.03.015-.043.055-.333 1.026-.726 1.785-1.203 2.284-.301.316-.693.588-1.174.822-.592.288-.981.933-.981 1.652v2.687h2.493a.75.75 0 1 1 0 1.5H3a.75.75 0 0 1-.75-.75v-3.437c0-1.284.708-2.458 1.825-3.001.33-.16.577-.332.746-.509.295-.309.59-.881.861-1.712a1.554 1.554 0 0 1 1.469-1.091h3.099zm8.75 9a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5h3zm-8 3.5a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5zm0-1.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm13 1.5a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5zm0-1.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"/>
          <path fill="${color}" d="M21 13.75a.75.75 0 1 1 0-1.5h7a.75.75 0 1 1 0 1.5h-7zm.7 3a.75.75 0 1 1 0-1.5H26a.75.75 0 1 1 0 1.5h-4.3z"/>
      </g>
  <div xmlns="" style="all:initial"/></svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const fixedAmount = (color = "#262626", mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <g fill="none" fill-rule="nonzero">
        <path fill="${color_mode}" d="M23.779 23l1.091-5.135-1.027-.219a1.95 1.95 0 0 1-1.502-2.312l.218-1.027-14.183-3.015-.218 1.027a1.95 1.95 0 0 1-2.313 1.502l-1.027-.218-1.091 5.135 1.027.218a1.95 1.95 0 0 1 1.502 2.313l-.27 1.272 14.182 3.014.27-1.271a1.95 1.95 0 0 1 2.313-1.502L23.78 23zm-.312 1.467l-1.027-.218a.45.45 0 0 0-.534.347l-.27 1.271 1.467.312.364-1.712zm1.715-8.07l.312-1.467-1.467-.312-.219 1.027a.45.45 0 0 0 .347.534l1.027.218zM4.518 22.23l.27-1.272a.45.45 0 0 0-.346-.534l-1.027-.218-.364 1.712 1.467.312zm2.391-11.25l-1.467-.31-.312 1.466 1.027.219a.45.45 0 0 0 .534-.347l.218-1.027zM5.02 9.046l21.52 4.574a.75.75 0 0 1 .577.89l-2.703 12.715a.75.75 0 0 1-.89.578L2.006 23.228a.75.75 0 0 1-.577-.89L4.13 9.624a.75.75 0 0 1 .889-.578zM8.233 7.82a.75.75 0 1 1-1.365-.623l1.447-3.169c.39-.801 1.349-1.15 2.146-.76l13.946 6.802a.75.75 0 1 1-.657 1.348L9.803 4.617c-.042-.02-.107.003-.132.052L8.233 7.821z"/>
        <path fill="${color}" d="M13.493 22.092a3.75 3.75 0 1 1 1.559-7.337 3.75 3.75 0 0 1-1.56 7.337zm.312-1.468a2.25 2.25 0 1 0 .935-4.401 2.25 2.25 0 0 0-.935 4.401z"/>
    </g>
  </svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const vipTierIcon = (color, mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
  
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g fill="none" fill-rule="nonzero">
          <path fill="${color_mode}" d="M14.012 22.186l-1.24.469a2.437 2.437 0 0 1-2.987-1.086l-.495-.88-2.15 4.956a.094.094 0 0 0 .11.128l2.472-.694a.75.75 0 0 1 .822.3l1.493 2.186a.094.094 0 0 0 .166-.022l1.809-5.357zm-5.79-2.806l-1.821-.622a2.438 2.438 0 0 1-1.604-2.774l.374-1.916a.937.937 0 0 0-.118-.666l-1.014-1.673a2.437 2.437 0 0 1 .559-3.165l1.54-1.236a.938.938 0 0 0 .34-.582l.312-1.942a2.437 2.437 0 0 1 2.446-2.049l2.022.033a.938.938 0 0 0 .625-.226l1.53-1.312a2.438 2.438 0 0 1 3.174 0l1.53 1.312c.174.15.396.23.625.226l2.022-.033a2.438 2.438 0 0 1 2.446 2.05l.313 1.941c.037.23.157.437.339.582l1.54 1.236a2.437 2.437 0 0 1 .56 3.165l-1.015 1.673a.938.938 0 0 0-.118.666l.374 1.916a2.437 2.437 0 0 1-1.604 2.774l-1.456.498 2.514 5.792a1.594 1.594 0 0 1-1.893 2.17l-1.953-.55-1.19 1.743a1.594 1.594 0 0 1-2.826-.389l-1.585-4.695-1.586 4.695a1.594 1.594 0 0 1-2.826.389l-1.19-1.742-1.952.548a1.594 1.594 0 0 1-1.893-2.169l2.459-5.668zm12.725.887l-.732 1.302a2.437 2.437 0 0 1-2.987 1.086l-.759-.287 1.747 5.175a.094.094 0 0 0 .167.022l1.492-2.187a.75.75 0 0 1 .823-.299l2.471.694a.094.094 0 0 0 .111-.128l-2.333-5.378zm-5.085.267l1.897.718a.938.938 0 0 0 1.149-.418l.975-1.736c.294-.522.77-.918 1.337-1.112l1.894-.647a.937.937 0 0 0 .617-1.067l-.375-1.917a2.437 2.437 0 0 1 .308-1.731l1.015-1.673a.937.937 0 0 0-.215-1.217l-1.541-1.236a2.437 2.437 0 0 1-.881-1.513l-.313-1.942a.938.938 0 0 0-.941-.788l-2.022.033c-.595.01-1.174-.2-1.626-.587l-1.53-1.312a.938.938 0 0 0-1.22 0L12.86 3.7a2.438 2.438 0 0 1-1.626.587l-2.022-.033a.937.937 0 0 0-.94.788l-.314 1.942a2.437 2.437 0 0 1-.88 1.513L5.535 9.734a.937.937 0 0 0-.215 1.217l1.015 1.673c.314.519.424 1.136.308 1.731l-.375 1.917c-.09.46.173.915.617 1.067l1.894.647c.567.194 1.043.59 1.337 1.112l.975 1.736a.938.938 0 0 0 1.15.418l1.896-.718c.555-.21 1.169-.21 1.724 0zM15 19.188c-4.15 0-7.52-3.307-7.52-7.393 0-4.087 3.37-7.393 7.52-7.393 4.15 0 7.52 3.306 7.52 7.393 0 4.086-3.37 7.393-7.52 7.393zm0-1.5c3.327 0 6.02-2.642 6.02-5.893 0-3.252-2.693-5.893-6.02-5.893-3.327 0-6.02 2.641-6.02 5.893 0 3.251 2.693 5.893 6.02 5.893z"/>
          <path fill="${color}" d="M13.194 14.862a.422.422 0 0 1-.6-.441l.284-1.945-1.397-1.41a.422.422 0 0 1 .23-.714l1.98-.336.937-1.743a.422.422 0 0 1 .744 0l.936 1.743 1.982.336c.336.058.47.47.229.713l-1.397 1.41.285 1.946a.422.422 0 0 1-.6.44L15 13.992l-1.806.87"/>
      </g>
  </svg>
  
    
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

const giftcardIcon = (color, mode) => {
  let color_mode = "#4d4d4d";
  color_mode = mode == "dark" ? "#f5f5f5" : "#4d4d4d";

  let logo = `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <g fill="none" fill-rule="nonzero">
        <path fill="${color}" d="M17.5 18.75a.75.75 0 1 1 0-1.5h5a.75.75 0 1 1 0 1.5h-5zm0 3a.75.75 0 1 1 0-1.5h3a.75.75 0 1 1 0 1.5h-3z"/>
        <path fill="${color_mode}" d="M15.759 12.75h-1.951c.646 1.236 2.134 1.857 4.61 1.831a.75.75 0 0 1 .016 1.5c-2.728.028-4.66-.69-5.684-2.178V24.25h11.632a1.868 1.868 0 0 0 1.868-1.868V12.75H15.759zM12.75 8.67a4.716 4.716 0 0 1 2.08-1.312l.236-.073a2.729 2.729 0 0 1 3.512 2.255 2.83 2.83 0 0 1-.313 1.71h7.985V7.618a1.868 1.868 0 0 0-1.868-1.868H12.75v2.92zm-4.526 4.08H3.75v9.632c0 1.032.836 1.868 1.868 1.868h5.632V13.923c-1.028 1.475-2.955 2.186-5.671 2.158a.75.75 0 1 1 .016-1.5c2.476.026 3.964-.595 4.61-1.831h-1.98zm3.026-4.046V5.75H5.618A1.868 1.868 0 0 0 3.75 7.618v3.632h1.983a2.806 2.806 0 0 1-.208-2.128 2.714 2.714 0 0 1 3.391-1.8l.26.08c.814.25 1.523.707 2.074 1.302zM5.618 4.25h18.764a3.368 3.368 0 0 1 3.368 3.368v14.764a3.368 3.368 0 0 1-3.368 3.368H5.618a3.368 3.368 0 0 1-3.368-3.368V7.618A3.368 3.368 0 0 1 5.618 4.25zm2.606 7h2.713a3.21 3.21 0 0 0-2.202-2.414l-.259-.08a1.214 1.214 0 0 0-1.56 1.004 1.319 1.319 0 0 0 1.308 1.49zm7.535 0a1.343 1.343 0 0 0 1.287-1.72 1.229 1.229 0 0 0-1.537-.812l-.237.073a3.225 3.225 0 0 0-2.212 2.459h2.699z"/>
    </g>
  </svg>
      `;
  let blob = new Blob([logo], { type: "image/svg+xml" });
  let url = URL.createObjectURL(blob);

  return url;
};

export {
  earnMorePoints,
  spendYourPoints,
  orderOnline,
  signUp,
  birthDay,
  fbLike,
  fbShare,
  twitterShare,
  twitterFollow,
  instaFollow,
  freeProduct,
  percentageCoupon,
  freeShippingCoupon,
  fixedAmount,
  vipTierIcon,
  giftcardIcon,
};
